export default __webpack_public_path__ + "static/media/carouselRightNavDisabled.93e48945.svg";